/**
 * Plain immutable class, deliberately NOT extending `AbstractFilterView`: both filters are applied
 * client-side, so the server-filter tooling it carries (`page`, `rows`, `queryParams`) would be unused
 * and would suggest the list is filtered by the server.
 */
class AiModelFilterView {
	readonly search: string;
	readonly providerId: number | null;

	constructor(search: string, providerId: number | null) {
		this.search = search;
		this.providerId = providerId;

		Object.freeze(this);
	}

	static createDefault(): AiModelFilterView {
		return new AiModelFilterView('', null);
	}

	/** Number of criteria that narrow the results. */
	get activeFilterCount(): number {
		return [this.search.length > 0, this.providerId !== null].filter(Boolean).length;
	}

	setSearch(search: string): AiModelFilterView {
		return new AiModelFilterView(search, this.providerId);
	}

	setProviderId(providerId: number | null): AiModelFilterView {
		return new AiModelFilterView(this.search, providerId);
	}

	hasActiveFilters(): boolean {
		return this.activeFilterCount > 0;
	}
}

export default AiModelFilterView;
